import { render, staticRenderFns } from "./ResourceDetailOptionItem.vue?vue&type=template&id=83fabf8c"
import script from "./ResourceDetailOptionItem.ts?vue&type=script&lang=ts&external"
export * from "./ResourceDetailOptionItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports